import type { TenantConfig } from '@/types/TenantConfig'

const white = '#FFFFFF'
const yellow = '#E8BB00'
const purple = '#A16888'
const black = '#000000'
const green = '#86cba3'

export const colorfactory: TenantConfig = {
  logo: 'assets/colorfactory/static/logo.png',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: black,
    secondaryColor: purple,
    logoHeight: '100px',
    footerBackgroundColor: yellow,
    footerTextColor: black,
    cartHeaderBackgroundColor: green,
    cartHeaderTextColor: black,
    dialog: {
      headerBackground: green,
      headerTextColor: black,
      headerIconColor: white,
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/colorfactory/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-100px',
        mobile: '-50px',
      },
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'Payment Information',
      },
    },
  },
}
